module.exports = __webpack_public_path__ + "img/lx-img3.298b9d23.png";